<template>
  <v-app id="login">
    <v-main class="background-login tpadding">
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-flex xs12 sm12 md8>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-row>
                  <v-col cols="4" class="d-flex align-content-end flex-wrap">
                    <v-btn v-if="!$route.params.last" center outlined color="pinkKonect" @click="before()"> Regresar</v-btn>
                  </v-col>
                  <v-col cols="4" class="d-flex align-content-center flex-wrap"> </v-col>
                  <v-col cols="4">
                    <v-img md1 :src="image" />
                  </v-col>
                </v-row>
                <privacy :privacyText="content" />
                <div class="text-center balign">
                  <v-btn v-if="$route.params.last" center outlined color="blueKonect" @click="acceptPolicies()" style="margin: 5px"> Acepto el aviso de privacidad</v-btn>
                  <v-btn center outlined :color="$route.params.last ? 'red' : 'pinkKonect'" @click="$route.params.last ? logout() : before()">
                    {{ $route.params.last ? "No estoy de acuerdo" : "Regresar" }}</v-btn
                  >
                </div>
                <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
                  {{ message }}
                </v-snackbar>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <main-footer />
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import mainFooter from "@/components/Footer";
import privacy from "@/components/Privacy";
import services from "@/utils/services";

export default {
  name: "login",
  components: { mainFooter, privacy },
  mixins: [validationMixin],
  validations: {
    username: {
      required,
      maxLength: maxLength(50),
    },
    password: {
      required,
      maxLength: maxLength(50),
    },
  },
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    loading: false,
    error: false,
    content: null,
    policiesId: "",
    message: "",
    host: process.env.VUE_APP_API_SERVER,
    path: "/pub/login",
    username: "",
    password: "",
    image: require("@/assets/logo.png"),
  }),
  computed: {
    usernameErrors() {
      const errors = [];
      if (!this.$v.username.$dirty) return errors;
      !this.$v.username.required && errors.push("El campo es obligatorio");
      !this.$v.username.maxLength && errors.push("El campo excede la longitud máxima");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("El campo es obligatorio");
      !this.$v.password.maxLength && errors.push("El campo excede la longitud máxima");
      return errors;
    },
  },
  mounted() {
    if (this.$route.params.last) {
      this.getPrivacyLatest();
    } else {
      this.getPrivacyPublic();
    }
  },
  methods: {
    ...mapActions("general", ["newUser", "clearData"]),
    clear() {
      this.$v.$reset();
      this.username = "";
      this.password = "";
    },
    forgot() {
      this.$router.push("/forgot");
    },
    before() {
      this.$router.push("/login");
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.login();
      } else {
        this.error = true;
        this.message = "Algunos datos del formulario son incorrectos";
      }
    },
    logout() {
      this.loading = true;
      if (this.$session.exists()) {
        let jwt = this.$session.get("jwt");
        let headers = {
          Authorization: "Bearer " + jwt,
        };
        this.axios
          .post(services.routes.logout, null, { headers })
          .then(() => {
            this.$session.destroy();
            this.clearData();
            this.$router.push("/login");
          })
          .catch(() => {
            this.$session.destroy();
            this.clearData();
            this.$router.push("/login");
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$router.push("/login");
      }
    },
    getPrivacyLatest() {
      services
        .ws("get", "dataPoliciesLatest")
        .then((res) => {
          if (res.ok) {
            this.content = res.data.contenido;
            this.policiesId = res.data.idpolitica_datos_externo;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPrivacyPublic() {
      this.axios.get(this.host + "/pub/dataPolicies/latest").then((res) => {
        this.content = res.data.data[0].contenido;
      });
    },
    acceptPolicies() {
      this.loading = true;
      let jwt = this.$session.get("jwt");
      let headers = {
        Authorization: "Bearer " + jwt,
      };
      let data = {
        data: {
          idpolitica_datos_externo: this.policiesId,
        },
      };
      this.axios
        .post(services.routes.acceptPolicies, data, { headers })
        .then((response) => {})
        .finally(() => {
          this.loading = false;
          this.$router.push("/client/home");
        });
    },
  },
};
</script>

<style scoped>
.background-login {
  background-color: white !important;
}
v-img {
  padding: 40px;
}
.balign {
  padding-top: 10px;
}
</style>
